module.exports = __webpack_public_path__ + "img/bubble-background-chystam-party.1127a66.svg";